// Vrati zajedno sa slikom ispod.
// import { ReactSVG } from "react-svg";
import { NoResultsProps } from "./types";
import { useTranslate } from "helpers";

const NoResults: React.FC<NoResultsProps> = (props) => {
  const { title, message } = props;
  const { t } = useTranslate();
  return (
    <div className="text-center flex flex-1 items-center justify-center py-12 w-full mx-auto">
      <div>
        <h2 className="text-sm mb-2 font-normal">
          {title ? title : t("admin.noresults")}
        </h2>
        {message && <p className="text-md font-light text-slate-600 mb-6 block">{message}</p>}
        {/* Slika praznog rezultata je zasad isključena.
        <ReactSVG
          src={icon ?? "/media/images/no-results.svg"}
          className="mx-auto w-fit "
        />
        */}
      </div>
    </div>
  );
};
export default NoResults;
